import {
  GoogleAuthProvider,
  getAuth,
  OAuthProvider,
  signInWithPopup,
} from 'firebase/auth';

const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

export async function signInWithApple() {
  const auth = getAuth();

  await signInWithPopup(auth, appleProvider);
}

const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export async function signInWithGoogle() {
  const auth = getAuth();

  await signInWithPopup(auth, googleProvider);
}
